import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const LABELS = {
  num_15m: "Per number / 15 min", num_day: "Per number / day", ip_15m: "Per IP / 15 min",
  ip_day: "Per IP / day", global_hour: "Global / hour", login_hour: "LOGIN on WhatsApp / hour",
};

export const WebAuthPanel = () => {
  const [d, setD] = useState(null);
  const [s, setS] = useState({});
  useEffect(() => {
    api.get("/admin/web-auth").then((r) => { setD(r.data); setS(r.data.settings); }).catch(() => {});
  }, []);
  if (!d) return null;
  const save = async () => {
    try { await api.put("/admin/web-auth", s); toast.success("Sign-in limits saved"); } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  const blocked = d.blocked_7d || {};
  return (
    <div className="mb-6 rounded-lg border border-white/10 bg-[#0B0F17] p-4" data-testid="web-auth-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-semibold text-slate-200">Dicta Web sign-in</p>
        <p className="text-xs text-slate-400" data-testid="web-auth-blocked">
          Active sessions {d.active_sessions} · Blocked (7 days): number {blocked.number || 0}, IP {blocked.ip || 0}, global {blocked.global || 0}, LOGIN {blocked.login || 0}
        </p>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-6">
        {Object.entries(LABELS).map(([k, label]) => (
          <label key={k} className="text-[10px] uppercase tracking-wide text-slate-500">{label}
            <input type="number" min="0" value={s[k] ?? ""} onChange={(e) => setS({ ...s, [k]: Number(e.target.value) })} data-testid={`web-auth-${k}`}
              className="mt-1 w-full rounded-md border border-white/10 bg-[#05070C] px-2 py-1 text-sm text-slate-200" />
          </label>
        ))}
      </div>
      <button onClick={save} data-testid="web-auth-save" className="mt-3 rounded-md bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-900">Save limits</button>
    </div>
  );
};
